export const getPrice = (price: string, data: { currency: '$' | '₩'; value: number; text: string }) => {
  return `₩${Number(price).toLocaleString('ko-KR')}`;
};
